import { WhatsappConversationModel } from "@jugl-web/rest-api/integrations/models/WhatsappConversation";
import { CRMChannel, WhatsappMessageModel } from "@jugl-web/rest-api";
import { createContext } from "react";
import { Subject } from "rxjs";
import { InstagramConversationModel } from "@jugl-web/rest-api/integrations/models/InstagramConversation";
import { InstagramMessageModel } from "@jugl-web/rest-api/integrations/models/InstagramMessage/InstagramMessageModel";
import { WebChatBotConversationModel } from "@jugl-web/rest-api/integrations/models/WebChatBotConversation";
import { WebChatBotMessageModel } from "@jugl-web/rest-api/integrations/models/WebChatBotMessage";
import { TwilioConversationModel } from "@jugl-web/rest-api/integrations/models/TwilioConversation";
import { TwilioMessageModel } from "@jugl-web/rest-api/integrations/models/TwilioMessage";
import { ContactInfoDrawerVariant } from "@web-src/modules/contacts/ContactsPage/components/ContactInfoDrawer";

export type ChannelListItem = {
  id: CRMChannel;
  name?: string;
};

export type ClientSupportPageContextValue = {
  refetchTrigger$: Subject<void>;
  selectedConversation?:
    | WhatsappConversationModel
    | InstagramConversationModel
    | WebChatBotConversationModel
    | TwilioConversationModel;
  selectConversation: (
    conversation?:
      | WhatsappConversationModel
      | InstagramConversationModel
      | WebChatBotConversationModel
      | TwilioConversationModel,
    auto?: boolean
  ) => void;
  selectedChannel: CRMChannel;
  selectChannel: (selectedChannel: CRMChannel) => void;
  replyMessage?:
    | WhatsappMessageModel
    | InstagramMessageModel
    | WebChatBotMessageModel
    | TwilioMessageModel;
  setReplyMessage: (
    conversationId: string,
    message?:
      | WhatsappMessageModel
      | InstagramMessageModel
      | WebChatBotMessageModel
      | TwilioMessageModel
  ) => void;
  incomingWhatsappMessages$: Subject<
    WhatsappMessageModel & { msg_status?: string }
  >;
  incomingInstagramMessages$: Subject<
    InstagramMessageModel & { msg_status?: string }
  >;
  incomingWebMessages$: Subject<
    WebChatBotMessageModel & { msg_status?: string }
  >;
  incomingTwilioMessages$: Subject<
    TwilioMessageModel & { msg_status?: string }
  >;
  sendWebMessage: (params: {
    conv_id: string;
    conv_name: string;
    text: string;
  }) => void;
  isSendingMessage: boolean;
  openedUserProfile?: string;
  setIsSendingMessage: (isSending: boolean) => void;
  setOpenedUserProfile: (userId?: string) => void;
  setOpenedContactInfo: (openedContactInfo?: {
    conversationId: string;
    variant: ContactInfoDrawerVariant;
  }) => void;
  availableChannels: ChannelListItem[];
};

export const ClientSupportContext =
  createContext<ClientSupportPageContextValue | null>(null);
